import axios from 'axios'
export default {

  login(email, pass, cb) {
    cb = arguments[arguments.length - 1]
    if (localStorage.token) {
      if (cb) cb(true)
      return
    }

    axios.post('/auth', { username: email, password: pass }).then(response => {
      var data = response.data
      if (data.access_token) {
        localStorage.token = data.access_token
        if (cb) cb(true)
      } else {
        if (cb) cb(false)
      }
    }).catch(error => {
      if (cb) cb(false)
    });

  },

  loginWithTempToken(tempToken, cb) {
    axios.post('/users/me/exchange_temp_token_for_token', { temp_token: tempToken }).then(response => {
      var data = response.data
      if (data.access_token) {
        localStorage.token = data.access_token
        if (cb) cb(true)
      } else {
        if (cb) cb(false)
      }
    }).catch(error => {
      if (cb) cb(false)
    });
  },

  getToken() {
    return localStorage.token || this.getParameterByName('t')
  },

  getGuestToken() {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZGVudGl0eSI6IjEiLCJpYXQiOjE1NjE4Mjk5MTUsIm5iZiI6MTU2MTgyOTkxNSwiZXhwIjoxNTkzMzY1OTE1fQ.hzsKClSO30q9aH54gRPnooy9HK6sUJE1YuCcbwmobRk';
  },

  logout(cb) {
    delete localStorage.token
    window.location.href = '/#/login'
  },

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  loggedIn() {
    return !!this.getToken();
  }

}
